// removed by extract-text-webpack-plugin
module.exports = {"settings":"ChecklistTemplateSettings__settings__25PAH","table":"ChecklistTemplateSettings__table__3swqh","row":"ChecklistTemplateSettings__row__7g05i","column":"ChecklistTemplateSettings__column__2A1-5","autosuggestColumn":"ChecklistTemplateSettings__autosuggestColumn__22HmB"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Pages/ChecklistTemplateDetailView/ChecklistTemplateSettings/ChecklistTemplateSettings.scss
// module id = 1772
// module chunks = 0